import { useQuery } from '@tanstack/react-query';
import { MaterialCategory } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY = ['globalMaterialCategories'];

export const useGlobalMaterialCategories = () => {
  return useQuery<MaterialCategory[], Error>({
    queryKey: GLOBAL_MATERIAL_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const categories = await warehouseService.getGlobalMaterialCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export default useGlobalMaterialCategories;
